import store from '../store/store'

import {unionBy} from 'lodash'

import tree from '@/helpers/tree.js'

const ACTIVE_ACCOUNT_ID = Number(localStorage.getItem('activeAccountId'))

export default {
  getAccountsHaveBlockedParent (allAccounts) {
    const accountsHaveBlockedParent = []

    for (let x = 0; x < allAccounts.length; x += 1) {
      if (allAccounts[x].blocked === 1) {
        const nodeParentId = allAccounts[x].parent_id

        const blockedNodeChildren = allAccounts.filter(el => el.parent_id === allAccounts[x].id)

        if (blockedNodeChildren.length > 0) {
          blockedNodeChildren.forEach(element => {
            element.parent_id = nodeParentId
            accountsHaveBlockedParent.push(element)
          })
        }
      }
    }

    return accountsHaveBlockedParent
  },

  transformToTree (accounts) {
    const allAccounts = JSON.parse(JSON.stringify(accounts))

    const accountsHaveBlockedParents = this.getAccountsHaveBlockedParent(allAccounts)

    const notBlockedAccounts = allAccounts.filter(el => el.blocked === 0)

    let finalAccounts = unionBy(notBlockedAccounts, accountsHaveBlockedParents, 'id')

    finalAccounts = finalAccounts.filter(el => el.blocked === 0)

    finalAccounts = tree.unshiftParentNode(finalAccounts, ACTIVE_ACCOUNT_ID)

    return tree.appendChildrenToNodes(finalAccounts, ACTIVE_ACCOUNT_ID)
  },

  async loadSubAccounts () {
    let accounts = await store.getters['settings/acceptedAccounts']

    if (accounts.length === 0 || accounts === undefined) {
      await store.dispatch('settings/acceptedAccounts')

      accounts = await store.getters['settings/acceptedAccounts']
    }

    if (accounts) {
      accounts.forEach(element => {
        element.label = element.name
      })
    }

    return accounts
  },

  async maptToTree () {
    const accounts = await this.loadSubAccounts()

    return this.transformToTree(accounts)
  },

  async mapAccountsToIds () {
    const accounts = await this.loadSubAccounts()

    return accounts.map(el => {
      return el.id
    })
  }
}
